// dateValidation.ts (or .js)
import { DateTime } from 'luxon'

type DateRangeValidationParams = {
  endDate: string | undefined,
  maxDays?: number,
  startDate: string | undefined,
}

export const validateDateRange = (params: DateRangeValidationParams) => {
  const { endDate, maxDays = 92, startDate } = params
  if (!startDate || !endDate) return true // Skip validation if missing

  const start = DateTime.fromISO(startDate)
  const end = DateTime.fromISO(endDate)

  if (!start.isValid || !end.isValid) return false

  const diffInDays = Math.abs(end.diff(start, 'days').days)
  return diffInDays <= maxDays
}

export const validateStartDate = (params: DateRangeValidationParams) => {
  const { endDate, maxDays, startDate } = params
  if (!endDate) return true
  return validateDateRange({ endDate, maxDays, startDate })
}

export const validateEndDate = (params: DateRangeValidationParams) => {
  const { endDate, maxDays, startDate } = params

  if (!startDate) return true
  return validateDateRange({ endDate, maxDays, startDate })
}
